import Tooltip from "@mui/material/Tooltip";

import { dateTimeFormatTimeAgo, dateFormat } from "core/datetime";

interface Props {
  date?: string | null | undefined;
  defaultValue?: JSX.Element | string | null | undefined;
  showTime?: boolean;
  showTooltip?: boolean;
}

interface DateFormatOptions {
  format: string;
  timeZone?: string;
}

export function DateWithTooltip({
  date,
  defaultValue = <>&mdash;</>,
  showTime,
  showTooltip = true
}: Props): JSX.Element {
  if (!date) {
    return <>{defaultValue}</>;
  }

  const newDate = new Date(date);
  let dateFormatOptions: DateFormatOptions = {
    format: showTime ? "Do MMM YYYY h:mma" : "Do MMM YYYY"
  };

  // N.B. I am not sure this does what the original author thought it did
  // Check if date passed in has time (is datetime)
  if (!newDate.getUTCMinutes()) {
    dateFormatOptions.timeZone = "utc";
  }

  return (
    <Tooltip
      title={dateTimeFormatTimeAgo(date) ?? ""}
      disableHoverListener={!showTooltip}
    >
      <time dateTime={date}>
        {/* @ts-ignore (dateFormat is not typed) */}
        {dateFormat(date, dateFormatOptions)}
      </time>
    </Tooltip>
  );
}
